import React from "react";

export const DefaultInput = ({
  label,
  value,
  inputName,
  onChange,
  placeholder,
  error,
}) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <div className="control">
        <input
          value={value}
          name={inputName}
          onChange={onChange}
          className={`input ${error && "is-danger"}`}
          type="text"
          placeholder={placeholder}
        />
      </div>
      {error && <span className="help is-danger">{error}</span>}
    </div>
  );
};

export const DefaultTextarea = ({
  label,
  value,
  inputName,
  onChange,
  placeholder,
  error,
  rows = "5",
}) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <div className="control">
        <textarea
          rows={rows}
          value={value}
          name={inputName}
          onChange={onChange}
          className={`textarea  ${error && "is-danger"}`}
          placeholder={placeholder}
          style={{ resize: "none" }}
        />
      </div>
      {error && <span className="help is-danger">{error}</span>}
    </div>
  );
};

export const DefaultCheckbox = ({
  label,
  value,
  inputName,
  onChange,
  error,
}) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <label
        className="checkbox is-flex is-align-items-center"
        style={{ gap: "10px" }}
      >
        <input
          defaultChecked={value}
          type="checkbox"
          name={inputName}
          onChange={onChange}
          id={inputName}
        />
        Si
      </label>
      {error && <span className="help is-danger">{error}</span>}
    </div>
  );
};

export const DefaultSelect = ({
  label,
  
  inputName,
  onChange,
  error,
  options,
}) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <div className={`select ${error && "is-danger"}`}>
        <select onChange={onChange} name={inputName} id={inputName}>
          <option defaultoption="true" >Selecciona una opción</option>
          {options.map(({ value, name }) => (
            <option
              key={value}
              value={value}
              
            >
              {name}
            </option>
          ))}
        </select>
        {error && <span className="help is-danger">{error}</span>}
      </div>
    </div>
  );
};

export const DefaultSelectHorizontal = ({
  label,
  
  inputName,
  onChange,
  error,
  options,
  idMessage,
}) => {
  return (
    <div className="field is-horizontal">
      <div className="field-label">
      <label className="label">{label}</label>
      </div>
      <div className="field-body">
      <div className={`select ${error && "is-danger"}`}>
        <select onChange={onChange} name={inputName} id={inputName} defaultValue="0">
          <option defaultoption="true" >Selecciona una opción</option>
          {options.map(({ value, name }) => (
            <option
              key={value}
              value={value}
              
            >
              {name}
            </option>
          ))}
        </select>
       
      </div>
      <p className="is-hidden help is-danger" id={idMessage}></p>
      </div>
    </div>
  );
};
